import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Message } from 'shared-components';

@Component({
    selector: 'app-mantenimiento-inc-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MantenimientoIncidenciasNewEditComponent {

    public showWarning: boolean;
    public mensajes = new Array<Message>();
    public consumosList: [];
    public multipleConsumos = false;

    @Input() consumoId;
    @Input() consumoCampoId;
    @Input() incidenciaId;

    @Output() close = new EventEmitter<boolean>();
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor() {}

    public pushMessage(mensaje) {
        if (mensaje) {
            this.showWarning = true;
            this.mensajes.push(mensaje);
        } else {
            this.showWarning = false;
            this.mensajes = [];
        }
    }
}
